import { AnyAction } from 'redux';
import { GET_API_EXPLORER_DOCUMENTATION } from '../constants';

const initialUserState = {
    apiDocumentation: null
};

export function apiExplorer(state = initialUserState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case GET_API_EXPLORER_DOCUMENTATION:
            return {
                ...state,
                apiDocumentation: payload
            };
        default:
            return state;
    }
}
